import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getBusinessWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const business = categorySpecificInfo.business;
  if (!isRecord(business)) {
    return [];
  }

  const attachments = business.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withBusinessWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const business = isRecord(categorySpecificInfo.business)
    ? categorySpecificInfo.business
    : {};
  const attachments = isRecord(business.attachments)
    ? business.attachments
    : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      business: {
        ...business,
        attachments: {
          ...attachments,
          warranty: {
            ...warranty,
            files,
          },
        },
      },
    },
  };
};

export const persistBusinessWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(db, `users/${userId}/vcards/active`, "business");
  await updateDoc(vcardRef, {
    "categorySpecificInfo.business.attachments.warranty.files": files,
    updatedAt: serverTimestamp(),
  });
};
